import { render, staticRenderFns } from "./singleindex.vue?vue&type=template&id=04ab923d&scoped=true&"
import script from "./singleindex.vue?vue&type=script&lang=js&"
export * from "./singleindex.vue?vue&type=script&lang=js&"
import style0 from "./singleindex.vue?vue&type=style&index=0&id=04ab923d&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ab923d",
  null
  
)

export default component.exports